export default __webpack_public_path__ + "static/media/persona-two.c22b466b.webp";